import { useTranslation } from 'react-i18next';

import InfoMessage from 'components/Notification/InfoMessage';
import Task from 'models/tasks/task';
import { toLocaleDateShort } from 'utils/datetime';

// The info message for an instance that is locked until its start date
export const LockedUntilStartMessage = (props: { task: Task }) => {
  const { t } = useTranslation(['task']);

  if (!props.task.isLockedUntilStart()) return null;

  return <InfoMessage message={t('task:LockedUntilStart', { date: toLocaleDateShort(props.task.startDateTime) })} />;
};
